import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesClientRoutingModule } from './pages-client-routing.module';
import { InicioClientComponent } from './inicio-client/inicio-client.component';
import {MatIconModule} from '@angular/material/icon';
import { CuentaComponent } from './cuenta/cuenta.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AgendarCitaComponent } from './agendar-cita/agendar-cita.component';
import { SharedModule } from '../shared/shared.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ConfirmacionCitaComponent } from './confirmacion-cita/confirmacion-cita.component';

@NgModule({
  declarations: [
    InicioClientComponent,
    CuentaComponent,
    AgendarCitaComponent,
    ConfirmacionCitaComponent
  ],
  imports: [
    CommonModule,
    PagesClientRoutingModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    SharedModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],

})
export class PagesClientModule { }
